import { MessageEntity, MessageEntitySchema, IMessageType, IMessage, MessageEntityAttachmentSchema } from "src/app/core/chat/entity/message";
import { SessionStore } from "src/app/store/session.service";
import { z } from "zod";


const MessageViewModalSchema = MessageEntitySchema.pick({
  $id: true,
  canEdit: true,
  editedAt: true,
  id: true,
  info: true,
  isDeleted: true,
  message: true,
  messageType: true,
  oneShot: true,
  origin: true,
  reactions: true,
  receiverId: true,
  requestId: true,
  requireUnlock: true,
  roomId: true,
  sendAttemp: true,
  sender: true,
  sending: true,
  sentAt: true
}).extend({
  attachments: MessageEntityAttachmentSchema.extend({
    blobURl: z.boolean()
  }).array().optional()
})

export type i = z.infer<typeof MessageViewModalSchema>
export class MessageViewModal {

  $id?: string
  id?: string
  roomId?: string
  $roomId: string
  receiverId?: number
  message?: string
  canEdit: boolean = false
  oneShot: boolean = false
  sentAt?: string
  requireUnlock: boolean = false
  info: typeof MessageViewModalSchema._type.info = []
  sender!: typeof MessageViewModalSchema._type.sender
  sending: boolean = false
  sendAttemp = 0
  messageType = IMessageType.normal
  attachments: typeof MessageViewModalSchema._type.attachments = []
  reactions: typeof MessageViewModalSchema._type.reactions = []
  requestId: string
  isDeleted: typeof MessageViewModalSchema._type.isDeleted = false

  status!: 'allViewed' | 'allReceived'| 'enviado'| 'enviar'
  messageUiType!: 'info-meeting'| 'my-message'| 'other-message'
  showReaction = false
  showMessage = false
  ballon = false
  showOneShot = false
  hour = ''

  constructor(model?: IMessage) {
    if(model) {
      Object.assign(this, model)
    }
    this.setMessageUIType()

    if(this._isDeleted == false && this.messageType != IMessageType.information) {
      this.showReaction = true
    }
    if(this._isDeleted == false && this.oneShot == false && this.messageType == IMessageType.normal) {
      this.showMessage = true
    }


    // Format the time to "HH:MM"
    if(this.sentAt) {
      const date = new Date(this.sentAt);

      // Format the time to "HH:MM"
      this.hour = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    }

  }

  setMessageUIType() {
    if(this.messageType == IMessageType.information) {
      this.messageUiType = 'info-meeting'
    } else if (this.sender?.wxUserId === SessionStore.user.UserId) {
      this.messageUiType = 'my-message'
    } else {
      this.messageUiType = 'other-message'
    }
  }

  delete() {
    this.showMessage = false
    this.isDeleted = true
  }


  get messageHasId() {
    if(this.id) {
      return true
    } else {
      return false
    }
  }

  get hasAttachment() {
    return this.attachments.length >= 1
  }

  haveSeen(info: typeof MessageEntitySchema._type.info) {
    return info.filter(e => typeof e.readAt == 'string' && e.memberId == SessionStore.user.UserId).length == 1
  }

  meSender() {
    return this.sender.wxUserId == SessionStore.user.UserId
  }

  get meSendOneShot() {
    return this.meSender() && this.oneShot == true
  }

  get _isDeleted() {
    return this.isDeleted || this.info.filter(e =>e.memberId == SessionStore.user.UserId && e.isDeleted).length == 1
  }

  get oneShotAlreadyViewsByMe() {
    return this._isDeleted == true && this.oneShot == true
  }

  get openByOther() {
    return this.isDeleted || this.info.filter(e =>e.memberId != SessionStore.user.UserId && e.isDeleted).length >= 1
  }

  get oneShotIsViewed() {
    return this.oneShot == true && this.info.filter(e =>e.memberId == SessionStore.user.UserId && e.isDeleted == true).length == 1
  }

  forceShowOneShot() {
    this.showOneShot = true;
  }
}
